__turbopack_context__.v({
  "arena": "monster-hunt-module__cYYTdG__arena",
  "arenaBackdrop": "monster-hunt-module__cYYTdG__arenaBackdrop",
  "battleStatus": "monster-hunt-module__cYYTdG__battleStatus",
  "bossPhase": "monster-hunt-module__cYYTdG__bossPhase",
  "bossPlate": "monster-hunt-module__cYYTdG__bossPlate",
  "combatHud": "monster-hunt-module__cYYTdG__combatHud",
  "combatScene": "monster-hunt-module__cYYTdG__combatScene",
  "comparisonGrid": "monster-hunt-module__cYYTdG__comparisonGrid",
  "criticalPulse": "monster-hunt-module__cYYTdG__criticalPulse",
  "damageNumber": "monster-hunt-module__cYYTdG__damageNumber",
  "damagePop": "monster-hunt-module__cYYTdG__damagePop",
  "difficultyIcon": "monster-hunt-module__cYYTdG__difficultyIcon",
  "difficultyOption": "monster-hunt-module__cYYTdG__difficultyOption",
  "difficultyPicker": "monster-hunt-module__cYYTdG__difficultyPicker",
  "eyebrow": "monster-hunt-module__cYYTdG__eyebrow",
  "gameShell": "monster-hunt-module__cYYTdG__gameShell",
  "guardIn": "monster-hunt-module__cYYTdG__guardIn",
  "guardPrompt": "monster-hunt-module__cYYTdG__guardPrompt",
  "guardPromptCopy": "monster-hunt-module__cYYTdG__guardPromptCopy",
  "guardPromptIcon": "monster-hunt-module__cYYTdG__guardPromptIcon",
  "guardTimerDrain": "monster-hunt-module__cYYTdG__guardTimerDrain",
  "guessButtons": "monster-hunt-module__cYYTdG__guessButtons",
  "healthGroup": "monster-hunt-module__cYYTdG__healthGroup",
  "healthLabel": "monster-hunt-module__cYYTdG__healthLabel",
  "healthTrack": "monster-hunt-module__cYYTdG__healthTrack",
  "itemCard": "monster-hunt-module__cYYTdG__itemCard",
  "itemCopy": "monster-hunt-module__cYYTdG__itemCopy",
  "itemFallback": "monster-hunt-module__cYYTdG__itemFallback",
  "itemImage": "monster-hunt-module__cYYTdG__itemImage",
  "itemMedia": "monster-hunt-module__cYYTdG__itemMedia",
  "itemShade": "monster-hunt-module__cYYTdG__itemShade",
  "questionDock": "monster-hunt-module__cYYTdG__questionDock",
  "questionHeader": "monster-hunt-module__cYYTdG__questionHeader",
  "radioIndicator": "monster-hunt-module__cYYTdG__radioIndicator",
  "resultActions": "monster-hunt-module__cYYTdG__resultActions",
  "resultIcon": "monster-hunt-module__cYYTdG__resultIcon",
  "resultIn": "monster-hunt-module__cYYTdG__resultIn",
  "resultPanel": "monster-hunt-module__cYYTdG__resultPanel",
  "resultStats": "monster-hunt-module__cYYTdG__resultStats",
  "roundBadge": "monster-hunt-module__cYYTdG__roundBadge",
  "sceneCaption": "monster-hunt-module__cYYTdG__sceneCaption",
  "sceneLoading": "monster-hunt-module__cYYTdG__sceneLoading",
  "sceneSpin": "monster-hunt-module__cYYTdG__sceneSpin",
  "setupCopy": "monster-hunt-module__cYYTdG__setupCopy",
  "setupGrid": "monster-hunt-module__cYYTdG__setupGrid",
  "setupStats": "monster-hunt-module__cYYTdG__setupStats",
  "setupVisual": "monster-hunt-module__cYYTdG__setupVisual",
  "startButton": "monster-hunt-module__cYYTdG__startButton",
  "timerTrack": "monster-hunt-module__cYYTdG__timerTrack",
  "timerValue": "monster-hunt-module__cYYTdG__timerValue",
  "unavailable": "monster-hunt-module__cYYTdG__unavailable",
  "versusDisc": "monster-hunt-module__cYYTdG__versusDisc",
});
